import { render, staticRenderFns } from "./AppFilesTable.vue?vue&type=template&id=5639feae&scoped=true"
import script from "./AppFilesTable.vue?vue&type=script&lang=js"
export * from "./AppFilesTable.vue?vue&type=script&lang=js"
import style0 from "./AppFilesTable.vue?vue&type=style&index=0&id=5639feae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5639feae",
  null
  
)

export default component.exports